import type { StopListSettingsModel } from '@/shared/generated'

import { useTranslation } from 'react-i18next'

import {
	StopListCustomRulesView,
	StopListDefaultRulesView,
} from '@/widgets/scenario-stoplist'

import {
	Card,
	CardContent,
	CardHeader,
	CardTitle,
} from '@/shared/components/ui/card'
import { Separator } from '@/shared/components/ui/separator'

export function ScenarioStopListSettingsCard({
	settings,
}: {
	settings?: StopListSettingsModel
}) {
	const { t } = useTranslation()

	if (!settings) return null

	return (
		<Card className='flex overflow-visible shadow-none'>
			<CardHeader className='pb-2'>
				<CardTitle>{t('stop_list')}</CardTitle>
			</CardHeader>
			<CardContent className='flex flex-col gap-4'>
				<StopListDefaultRulesView settings={settings} />
			</CardContent>
			<Separator />
			<CardHeader className='pb-2'>
				<CardTitle>{t('stop_list.custom_rules.title')}</CardTitle>
			</CardHeader>
			<CardContent className='flex flex-col gap-4'>
				<StopListCustomRulesView settings={settings} />
			</CardContent>
		</Card>
	)
}
